module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_8011.801bd490.png";